import { useTranslation } from 'react-i18next'

import { Box, Button, Divider, Stack, TextField, Typography } from '@mui/material'
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded'

import AudioViewer from '@/components/ui/preview/AudioViewer'

export type TranscriptionsProps = {
  dictaphones?: Array<{
    filename: string
    key: string
    src: string
    text: string
  }>
  onDeleteDictaphone?: (filename: string, key: string) => void
}

export function Transcriptions(props: TranscriptionsProps) {
  const { dictaphones, onDeleteDictaphone } = props
  const { t } = useTranslation()

  return (
    <Box px={5} py={4}>
      <Typography variant="h6" component="div" sx={{ fontSize: '24px', fontWeight: 500 }}>
        {t('page.liveConsultation.transcriptions.title')}
      </Typography>
      <Stack divider={<Divider />} spacing={3} mt={2}>
        {dictaphones?.map((dictaphone) => (
          <Stack key={dictaphone.key} spacing={2}>
            <AudioViewer src={dictaphone.src} sx={{ width: '100%' }} />
            <TextField fullWidth InputProps={{ readOnly: true }} minRows={4} multiline={true} defaultValue={dictaphone.text} />
            <Stack direction="row" justifyContent="end">
              <Button
                color="error"
                onClick={() => {
                  onDeleteDictaphone?.(dictaphone.filename, dictaphone.key)
                }}
                startIcon={<DeleteRoundedIcon />}
                variant="contained"
              >
                {t('common:button.delete.label')}
              </Button>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}

export default Transcriptions
